module.exports = __webpack_public_path__ + "img/lihexu.1e5b3372.jpg";